export default __webpack_public_path__ + "static/media/loc_img_11.37004ca7.jpg";